import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-white p-5 shadow-sm" }
const _hoisted_2 = { class: "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_3 = { class: "flex min-w-0 items-center gap-3.5" }
const _hoisted_4 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-emerald-100 bg-emerald-50" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-2.5" }
const _hoisted_7 = { class: "truncate text-xl font-bold tracking-tight text-gray-900" }
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-xs text-gray-600"
}
const _hoisted_9 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_10 = {
  key: 0,
  class: "inline-flex items-center rounded-md border border-gray-200 bg-gray-50 px-3.5 py-2 text-xs font-medium text-gray-700"
}

import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaHeader',
  props: {
    title: {},
    subtitle: {},
    statusLabel: {},
    statusVariant: {},
    summary: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(SVGWhatsApp, { class: "h-7 w-7 text-[#25D366]" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.title), 1),
            (_ctx.statusLabel)
              ? (_openBlock(), _createBlock(_component_UiBadge, {
                  key: 0,
                  variant: _ctx.statusVariant,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["mr-1.5 inline-block h-1.5 w-1.5 rounded-full", {
                                    'bg-emerald-500': _ctx.statusVariant === 'emerald',
                                    'bg-amber-500': _ctx.statusVariant === 'yellow',
                                    'bg-gray-400': _ctx.statusVariant === 'gray',
                                }]),
                      "aria-hidden": "true"
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_ctx.statusLabel), 1)
                  ]),
                  _: 1
                }, 8, ["variant"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.subtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.subtitle), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.summary)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.summary), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "actions")
      ])
    ])
  ]))
}
}

})